import WebsiteBehaviors from "../website-behaviors/index.js";

class AspenLawEbooks extends WebsiteBehaviors {
	identifier() {
		return "AspenLawEbooks";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return location.host === "ebooks.aspenlaw.com";
	}

	shouldFrameTakeControl() {
		return true;
	}
}

export default AspenLawEbooks;
